import { render, staticRenderFns } from "./RowBlockBuyingGreenCardInsurance.vue?vue&type=template&id=3a739c27&"
import script from "./RowBlockBuyingGreenCardInsurance.vue?vue&type=script&lang=js&"
export * from "./RowBlockBuyingGreenCardInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports